module.exports = __webpack_public_path__ + "img/cover.9776950e.jpg";